var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('div',{staticClass:"filter-selector-controller",attrs:{"scrollY":_vm.scrollY}})])
}
var staticRenderFns = []

export { render, staticRenderFns }